import { render, staticRenderFns } from "./ChangeAdditionalFields.vue?vue&type=template&id=5d5db4ef&lang=pug&"
import script from "./ChangeAdditionalFields.vue?vue&type=script&lang=js&"
export * from "./ChangeAdditionalFields.vue?vue&type=script&lang=js&"
import style0 from "./ChangeAdditionalFields.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports